export default __webpack_public_path__ + "static/media/passport-logo.af390787.png";